import watch from 'redux-watch'

import { setInCartService } from 'storage/cart'
import { AppStore } from 'src/client/store'
import { bookingUrlPattern } from 'constants/url'
import { pathChange } from 'actions/NavigationActions'
import { getUtmParams } from 'storage/checkout'

export function watchNavigation(store: AppStore) {
  store.subscribe(
    watch(store.getState, 'router.location.pathname')((path: string) => {
      store.dispatch(pathChange())
      const state = store.getState()

      if (bookingUrlPattern.test(path)) {
        return setInCartService(
          state,
          getUtmParams(state.utm),
        )
      }
    }),
  )
}
